import { icon, iconButton } from "../kit/components.ts";
import { h } from "../kit/dom.ts";

/** Quantos avisos ficam na tela (o mais velho sai ao chegar outro). */
export const NOTICE_MAX = 4;

/**
 * Aviso temporário (F81: o cartão do mockup ui-b, com o ◆!, o título, o texto e o ✕). Na partida, os avisos
 * ficam na coluna da direita, sob o minimapa (a cena põe o `#toasts` lá); fora dela, no canto de cima. O
 * título só vem quando quem avisa o dá (`title`): a mensagem não é cortada em ": " ou ". " (revisão da F81:
 * os apelidos aceitam os dois, e "J. Silva morreu." virava o título "J").
 */
export function toast(message: string, kind: "info" | "error" = "info", ms = 4500, title?: string): void {
  let container = document.getElementById("toasts");
  if (!container) {
    container = h("div", { id: "toasts", role: "status" });
    document.body.appendChild(container);
  }
  const element = h(
    "div",
    { class: `toast hud-cartao ${kind === "error" ? "error" : ""}`.trim() },
    icon("hud-alerta", "aviso-icone"),
    h("div", { class: "aviso-corpo" }, title ? h("strong", { class: "aviso-titulo" }, title) : null, h("span", { class: "aviso-texto" }, message.trim())),
    iconButton({ icon: "icone-x", label: "Dispensar aviso", onClick: () => element.remove() }),
  );
  container.appendChild(element);
  // Muitos de uma vez: o mais velho sai.
  while (container.childElementCount > NOTICE_MAX) container.firstElementChild?.remove();
  setTimeout(() => element.remove(), ms);
}
